
import { commonFilterWrapper } from '../utils'


export default {

  /**
   * Config reference
   * @type {string}
   */
  uuid: '81daa378-e75a-4a5a-b224-4c48849a8bef',

  /**
   * Use to group table configurations
   *  Configs for realisation index should not be used for the statistics dashboard
   */
  category: 'rvb-customer-reporting',

  /**
   * Access requirements
   */
  access: {
    requirements: [],
    supersededBy: [],
  },

  /**
   *
   */
  controlsComponentName: 'RVBControls',


  // Minimal width of the table
  minWidth: '920px',
  maxWidth: '1900px',
  pageSize: 1000,
  pageSizeOptions: [1000],
  visualisation: 'table',

  /**
   * CSS Grid config
   *
   * @type {object}
   */
  layouts: {
    default: {
      id: 'default',
      label: 'Standaard',
      filters: {
        filters: [],
        columns: '',
        area: '',
      },
      header: { // copied to row
        properties: [
          'Region', 'status', 'demand', 'extra_demand',
        ],
        columns: '1fr 1fr 1fr 1fr',
        area: '"Region status demand extra_demand"',
      },
      row: {
        properties: [
          'Region', 'status', 'demand', 'extra_demand', 'status_two', 'demand_two', 'extra_demand_two',
        ],
        columns: '1fr 1fr 1fr 1fr',
        area: '"Region status_two demand_two extra_demand_two" ". status demand extra_demand"',
      },
    },
  },

  headerLabels: {
    Region: 'Regio',
    status: 'Status',
    demand: 'Behoefte',
    extra_demand: 'Extra Behoefte',
  },
  cellComponents: {
    Region: null,

    // completed
    status: null,
    demand: null,
    extra_demand: null,

    // not completed
    status_two: null,
    demand_two: null,
    extra_demand_two: null,
  },

  /**
   * sorting options
   *  Note that a header may be sorted by a different field than itself
   *  An example is the referencenr used to sort the reference column numerically
   */
  sorting: {
    default: {
      type: 'string',
      sortBy: 'RegionSort',
      direction: 'up',
    },
  },


  /**
   * Take a record and convert it to the data we use for displaying / sorting / filtering records in this table
   * @type {Function}
   */
  dataMapper: (record) => {

    let location = record.CurrentLocation || {}

    let data = {
      Region: location?.Object?.Address?.RVBRegion || '-',
      completed: location?.Progress?.AllPartiesSignedDate || false,
      demand: location?.ParkingAndChargePoints?.ChargePointNeedsGovernmentOffices || 0,
      extra_demand: location?.ParkingAndChargePoints?.ExtraNeedChargePoints || 0,
    }

    // Customer records are already mapped prior to being mapped by this function
    // See RVBCustomers.vue component
    let isCompleted = record.status.isCompleted
    let isCancelled = record.status.isCancelled
    let isOnHold = record.status.isOnHold

    return Object.assign(data, {
      /**
      * Filter params
      */
      filteredOut: false,
      filterReason: null,
    }, {
      categories: {
        all: true,
        actief: isCompleted !== true && isCancelled !== true && isOnHold !== true,

        gepauzeerd: isOnHold === true && isCancelled !== true,
        afgerond: isCompleted === true,
        geannulleerd: isCancelled === true,
      },
    })
  },

  /**
   * Data can be aggregated
   */
  dataPresentationMapper: ({ records }) => {

    let entry = {
      Region: '',

      // completed
      status: 'In bedrijf',
      demand: 0,
      extra_demand: 0,

      // not completed
      status_two: 'Niet in bedrijf',
      demand_two: 0,
      extra_demand_two: 0,
    }

    let data = {
      'total': {
        Region: 'Totaal',
        RegionSort: 'ZZZZZZZZZZZZZZZZZZZ',
        position: 999,
        demand: 0,
        extra_demand: 0,
        status: '',
        status_two: '',
        demand_two: '',
        extra_demand_two: '',
      },
    }

    records.forEach(record => {

      let Region = record.Region

      if (! data[Region]) {
        data[Region] = Object.assign({}, entry, {
          Region: Region,
          RegionSort: Region,
        })
      }

      let demand = record.demand
      let extra_demand = record.extra_demand

      if (record.completed) {
        data[Region].demand = data[Region].demand + parseInt(demand, 10)
        data[Region].extra_demand = data[Region].extra_demand + parseInt(extra_demand, 10)
      } else {
        data[Region].demand_two = data[Region].demand_two + parseInt(demand, 10)
        data[Region].extra_demand_two = data[Region].extra_demand_two + parseInt(extra_demand, 10)
      }

      data['total'].demand = data['total'].demand + parseInt(demand, 10)
      data['total'].extra_demand = data['total'].extra_demand + parseInt(extra_demand, 10)
    })

    return Object.values(data)
  },

  totalMapper: () => {

    return null
  },


  /**************************************************************************
   * Filter configuration
   *
   * @type {object[]}
   */
  filters: {


    /**
     * Note: The 'cost' is high so that we can 'undo' this filter for the counter per category
     */
     category: {
      cost: 9999,
      id: 'category',
      label: 'Category',
      position: '',
      componentName: null,
      hidden: true,
      options: [{
          text: 'Alles',
          value: 'all',
          reset: true,
          layout: 'default',
        }, {
          text: 'Actief',
          value: 'actief',
        }, {
          text: 'Gepauzeerd',
          value: 'gepauzeerd',
        }, {
          text: 'Afgerond',
          value: 'afgerond',
        }, {
          text: 'Geannuleerd',
          value: 'geannulleerd',
        },
      ],
      prep: ({ filter }) => {
        return {
          id: filter.id,
          value: filter.filters[0].value,
          callback: commonFilterWrapper({ callback: filter.callback }),
        }
      },
      callback: ({ record, value }) => record.categories[value] === true,
    },
  },

}
